export const formatCartLines = (lines) => {
  if (!lines) return [];
  return lines.map((line) => ({
    ...line.node,
  }));
};

export const formatCart = (cart) => {
  const formatedLines = formatCartLines(cart?.lines?.edges);
  const gwpLinkInCart = formatedLines.find((line) =>
    line.attributes.find((attribute) => attribute.key === '_gwp_link'),
  );

  const subtotal = cart?.cost?.subtotalAmount || { amount: 0 };
  let gwpLinkRemain = 1;
  if (gwpLinkInCart) {
    const gwpLinkThreshold = gwpLinkInCart.attributes.find(
      (attr) => attr.key === '_gwp_link_threshold',
    )?.value;
    const gwpLinkPrice = gwpLinkInCart.customKnife
      ? gwpLinkInCart.knifePrice?.priceV2
      : gwpLinkInCart.cost?.subtotalAmount;

    gwpLinkRemain =
      Number.parseFloat(gwpLinkThreshold) -
      subtotal.amount +
      Number.parseFloat(gwpLinkPrice.amount);
    if (gwpLinkRemain <= 0) {
      subtotal.amount -= Number.parseFloat(gwpLinkPrice.amount);
    }
  }

  return {
    ...cart,
    subtotal,
    lines: formatedLines,
    gwpLinkFree: gwpLinkRemain <= 0,
  };
};

/**
 * Makes product data more consumable
 * @param {Object} data product object
 */

const formatProduct = (data) => {
  const variants = window.formatVariants(data.variants);
  return {
    ...data,
    images: data?.images?.edges.map((edge) => edge.node),
    horizontalImage: data?.horizontalImage?.value,
    variants,
  };
};

/**
 * Makes product data more consumable
 * @param {Array} data array of product objects
 */

export const formatProducts = (data) =>
  data.map((product) => formatProduct(product.node));

/**
 * Makes variant data more consumable
 * @param {Array} data array of variant objects
 */
window.formatVariants = (data) =>
  data.edges.map((variant) => window.formatVariant(variant.node));

/**
 * Makes variant data more consumable
 * @param {Object} data variant object
 */
window.formatVariant = (data) => ({
  ...data,
  id: data.id.split('gid://shopify/ProductVariant/')[1],
  priceV2: data.priceV2?.amount,
  compareAtPrice: data.compareAtPrice?.amount,
});

export const formatMetaobject = (metaobject) => {
  if (!metaobject) return false;
  switch (metaobject.reference?.__typename) {
    case 'Metaobject':
      // eslint-disable-next-line no-case-declarations
      const fields = metaobject.reference?.fields
        ? metaobject.reference?.fields
        : metaobject.fields;
      // eslint-disable-next-line no-case-declarations
      const formattedMetaobject = {};
      // eslint-disable-next-line no-return-assign, array-callback-return
      fields.map((field) => {
        // eslint-disable-next-line max-len, no-unused-expressions
        field.reference
          ? (formattedMetaobject[field.key] = formatMetaobject(field))
          : (formattedMetaobject[field.key] = field.value);
      });
      // eslint-disable-next-line no-unused-expressions
      metaobject.reference?.handle
        ? (formattedMetaobject.handle = metaobject.reference?.handle)
        : null;
      return formattedMetaobject;
    case 'MediaImage':
      // eslint-disable-next-line no-case-declarations
      const imageMetaobject = {};
      if (metaobject.reference?.image?.url)
        imageMetaobject.url = metaobject.reference.image.url;
      // eslint-disable-next-line max-len
      if (metaobject.reference?.image?.altText)
        imageMetaobject.alt = metaobject.reference.image.altText;
      // eslint-disable-next-line max-len
      if (metaobject.reference?.image?.height)
        imageMetaobject.height = metaobject.reference.image.height;
      // eslint-disable-next-line max-len
      if (metaobject.reference?.image?.width)
        imageMetaobject.width = metaobject.reference.image.width;
      return imageMetaobject;
    default:
      return null;
  }
};
